import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { MenuQuickFilterCard } from './MenuQuickFiltersCard/MenuQuickFiltersCard'

export const MenuQuickFilters = observer(() => {
  const { quickFiltersMenuStore } = useConversationMenuContext()
  const { quickFilters, initInboxQuickFilter } = quickFiltersMenuStore

  useEffect(() => {
    initInboxQuickFilter()
  }, [])

  if (quickFilters.length === 0) return null

  return (
    <Box mb={'20px'}>
      {quickFilters.map((item) => (
        <MenuQuickFilterCard key={item.id} item={item} />
      ))}
    </Box>
  )
})
